import React from "react";
import ReactDOM from "react-dom/client";

import { ConfigProvider } from "antd";
import { BrowserRouter, matchRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { App as AntApp } from "antd";
import { HelmetProvider } from "react-helmet-async";

import App from "@/App";
import routes from "@/router";
import store from "./store";

import "antd/dist/reset.css";
import "normalize.css";
import "@/assets/css/index.less";

// import "lib-flexible/flexible";

import "./utils/rem";

const rootElement = document.getElementById("root");

const appTree = (
	<HelmetProvider>
		<ConfigProvider>
			<Provider store={store}>
				<BrowserRouter>
					<AntApp>
						<App />
					</AntApp>
				</BrowserRouter>
			</Provider>
		</ConfigProvider>
	</HelmetProvider>
);

// 当前 URL 命中的那几个路由组件（含 Layouts）必须在首帧之前就位。
// 预渲染页的静态 HTML 里是完整正文，而未就位的路由组件首帧渲染的是 Loading，
// 两者不符会让 React 判定 hydration 失败（#418），继而整个 root 改走客户端渲染
// （#423），预渲染出来的那棵 DOM 被整棵丢弃重渲染 —— 首屏白一下，
// hydration 的收益全部作废。
// matchRoutes 直接问路由表要"这个 URL 命中哪几层"，不另维护一份路径表，
// 日后加路由不会漏。
const preloadMatchedRoutes = () => {
	try {
		const matched = matchRoutes(routes, window.location) || [];
		return Promise.all(
			matched
				.map((match) => match.route.element?.type?.preload)
				.filter((preload) => typeof preload === "function")
				.map((preload) => preload()),
		);
	} catch (err) {
		// 预加载只是为了首帧对得上，不该拦住页面挂载
		return Promise.resolve();
	}
};

// chunk 取不到时照常挂载：组件自己会在 effect 里重试，不额外制造一个白屏分支
const mount = () => {
	// react-snap 预渲染后，首次加载走 hydrateRoot 挂载静态 HTML；否则正常 createRoot
	if (rootElement.hasChildNodes()) {
		ReactDOM.hydrateRoot(rootElement, appTree);
	} else {
		ReactDOM.createRoot(rootElement).render(appTree);
	}
};

preloadMatchedRoutes().then(mount, mount);
